import 'bootstrap';
import 'slick-carousel';

const $ = require('jquery');

const $root = $('html, body');

global.$ = $;

global.jQuery = $;

require('popper.js');

const defaultsCarouselOptions = {
	autoplay: true,
	infinite: true,
	lazyLoad: 'ondemand',
	slidesToShow: 6,
	slidesToScroll: 6,
	speed: 400,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 4,
				slidesToScroll: 4,
			},
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
			},
		},
	],
};

document.addEventListener('DOMContentLoaded', () => {
	$('.carousel-items').slick(defaultsCarouselOptions);

	const showCarouselSpecificOptions = {
		autoplay: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 1081,
				settings: {
					arrows: false,
				},
			},
			{
				breakpoint: 992,
				settings: {
					arrows: false,
					slidesToShow: 4,
					slidesToScroll: 4,
				},
			},
			{
				breakpoint: 480,
				settings: {
					arrows: false,
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
		],
	};

	const showCarouselOptions = { ...defaultsCarouselOptions, ...showCarouselSpecificOptions };

	$('.shows-carousel--items').slick(showCarouselOptions);

	const videoCarouselSpecificOptions = {
		autoplay: false,
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 4,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
		],
	};

	const videoCarouselOptions = { ...defaultsCarouselOptions, ...videoCarouselSpecificOptions };

	$('.video-carousel-items').slick(videoCarouselOptions);

	// featured rotator on homepage
	const rotator = document.querySelector('.featured-rotator-slider');
	const slides = document.querySelectorAll('.featured-rotator-slide');
	const prevBtn = document.querySelector('.rotator-prev-btn');
	const nextBtn = document.querySelector('.rotator-next-btn');
	const arrowsContainer = document.querySelector('.featured-rotator-controls');
	const dotsContainer = document.querySelector('.featured-rotator-controls-dots');
	const autoRotation = rotator ? rotator.getAttribute('data-auto-rotation') : '';

	let interval;
	let slideIndex = 0;

	// for initial page load to display image on autorotate on
	if (rotator) {
		rotator.style.transform = `translateX(-${slideIndex * 100}%)`;
	}

	// dynamically creating dots as per the number of slides
	for (let index = 0; index < slides.length; index += 1) {
		const dot = document.createElement('button');
		dot.classList.add('dot-btn');

		if (index === 0) {
			dot.classList.add('active');
		}

		dot.setAttribute('aria-label', 'Rotator navigation buttons');

		dotsContainer.appendChild(dot);
	}

	// update slider dots
	function updateDots() {
		const dots = document.querySelectorAll('.dot-btn');
		dots.forEach((dot, index) => {
			dot.classList.toggle('active', index === slideIndex);
		});
	}

	function updateSlider() {
		if (rotator) {
			const slideWidth = rotator.clientWidth;
			rotator.style.transform = `translateX(-${slideWidth * slideIndex}px)`;
		}
	}

	// Adding margin bottom to dots as per the content height
	function updateDotsContainerMargin() {
		const currentSliderContent = document.querySelector('.featured-rotator-slider-content');
		const slideContentHeight = currentSliderContent ? currentSliderContent.marginBottom : '';
		const containerMarginBottom = 50;
		if (arrowsContainer) {
			arrowsContainer.style.marginBottom = `${slideContentHeight + containerMarginBottom}`;
		}
		if (dotsContainer) {
			dotsContainer.style.marginBottom = `${slideContentHeight + containerMarginBottom}`;
		}
	}

	// on dots click change the slide
	if (dotsContainer) {
		dotsContainer.addEventListener('click', (event) => {
			const clickedDot = event.target;
			if (clickedDot.classList.contains('dot-btn')) {
				slideIndex = Array.from(dotsContainer.children).indexOf(clickedDot);
				updateSlider();
				updateDots();
				updateDotsContainerMargin();
			}
		});
	}

	function nextAutoSlide() {
		slideIndex = (slideIndex + 1) % rotator.children.length;
		rotator.style.transform = `translateX(-${slideIndex * 100}%)`;
		updateDots();
	}

	function startAutoRotate() {
		interval = setInterval(nextAutoSlide, 6000);
	}

	function stopAutoRotate() {
		clearInterval(interval);
	}

	// check if autoRotation is active or not.
	// settings on the featured Rotator component: Auto-rotate Rotator Banner Toggle settings
	if (autoRotation === '1') {
		// stop auto rotation on mouse entre and start as it leaves
		rotator.addEventListener('mouseenter', () => {
			stopAutoRotate();
		});

		rotator.addEventListener('mouseleave', () => {
			startAutoRotate();
		});

		startAutoRotate();
	}

	// prev btn click
	if (prevBtn) {
		prevBtn.addEventListener('click', () => {
			// get prev slide
			slideIndex = (slideIndex - 1 + rotator.children.length) % rotator.children.length;
			updateSlider();
			updateDots();
			updateDotsContainerMargin();
			stopAutoRotate();
		});
	}

	// next btn click
	if (nextBtn) {
		nextBtn.addEventListener('click', () => {
			// get next slide
			slideIndex = (slideIndex + 1) % rotator.children.length;
			updateSlider();
			updateDots();
			updateDotsContainerMargin();
			stopAutoRotate();
		});
	}

	// resize slider to fit in the screen when checking media on manual strech and compress
	function resizeSlider() {
		updateSlider();
		updateDots();
		updateDotsContainerMargin();
	}

	window.addEventListener('resize', resizeSlider);
	window.addEventListener('load', updateDotsContainerMargin);

	updateSlider();

	// smooth scrolling, disabled for accordion links
	$('a[href^="#"]:not([data-toggle])').on('click', function smoothScroll() {
		const href = $.attr(this, 'href');
		$root.animate({
			scrollTop: $(href).offset().top,
		}, 500, () => {
			window.location.hash = href;
		});

		return false;
	});
});

// Define learnMoreText globally (outside of any function or block)
const learnMoreText = 'LEARN MORE';

// PROVIDERS START -- Replace Learn More text with the Alt text of the image.
const changeLearnMoreButtonText = (item, index, setNames) => {
	const link = setNames[index];
	const isMobile = $(window).width() < 768;

	if (isMobile) {
		link.innerText = item.getAttribute('alt');
	} else if (link.innerText !== learnMoreText) {
		// Update only if the current content is not the default learnMoreText
		link.innerText = learnMoreText;
	}
};

const updateLearnMoreButtonText = () => {
	const sectionProviders = document.getElementById('section-providers');
	if (sectionProviders !== null) {
		const images = Array.from(sectionProviders.getElementsByTagName('img'));
		const links = Array.from(sectionProviders.getElementsByTagName('a'));
		images.forEach((item, index) => {
			changeLearnMoreButtonText(item, index, links);
		});
	}
};

// Trigger the function on window resize or load
$(window).on('resize load', updateLearnMoreButtonText);
// PROVIDERS END

// Change the background colour for H2 to match the section background colour
const sectionBg = document.getElementById('section-providers');
const sectionBgColour = sectionBg ? getComputedStyle(sectionBg).backgroundColor : '';
$('#section-providers .info-card-main-title').css('background', sectionBgColour);
